import React from 'react';
import Gallery from '../components/Gallery';
import { newBuildsImages } from '../utils/imageUtils';

const NewBuilds: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">New Builds</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Transform your vision into reality with our expert new build services. We specialize in creating
            beautiful, functional, and sustainable homes that exceed expectations.
          </p>
          <div className="mt-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Our New Build Projects</h2>
            <Gallery images={newBuildsImages} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewBuilds; 